import AxiosHelper from '@shared/infra/protocols/http/AxiosHelper';
import config from '@/Constants';
import { QuerySupergroupsResponse } from '@queryfilter/domain/interfaces';

async function fetchDashSupergroups(): Promise<QuerySupergroupsResponse[]> {
  const urlAux = config.DASHBOARD_MOCK ? config.DASHBOARD_MOCK_URL : '';

  const url = `${urlAux}get_dashboard_super_groups`;

  const response = await AxiosHelper.get({ url });
  const data: QuerySupergroupsResponse[] = response.body;
  return data;
}

export default fetchDashSupergroups;
